import { render } from "./CardHistory.vue?vue&type=template&id=4dcb7494&scoped=true"
import script from "./CardHistory.vue?vue&type=script&lang=js"
export * from "./CardHistory.vue?vue&type=script&lang=js"

import "./CardHistory.vue?vue&type=style&index=0&id=4dcb7494&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcb7494"]])

export default __exports__